import { c as _c } from "react/compiler-runtime";
import { twMerge } from "tailwind-merge";
import { defaultInputErrorStyles, InputErrorStyleProps, inputErrorStylesMap } from "@/components/global/form/inputs/styles/input-error.styles";
interface InputErrorProps {
  error?: string;
  styles?: InputErrorStyleProps;
}

/**
 * Form field error message component
 * @param {string} [error] - Error message to display
 * @param {InputErrorStyleProps} [styles] - Custom styles for the error message
 * @example
 * <InputError
 *   error="This field is required"
 *   styles={{
 *     textColor: "danger2",
 *     fontSize: "sm",
 *     marginTop: "md"
 *   }}
 * />
 */
export const InputError: React.FC<InputErrorProps> = t0 => {
  const $ = _c(5);
  const {
    error,
    styles: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    const styles = t1 === undefined ? {} : t1;
    const mergedStyles = {
      ...defaultInputErrorStyles,
      ...styles
    };
    t2 = twMerge(inputErrorStylesMap.fontSize[mergedStyles.fontSize], inputErrorStylesMap.marginTop[mergedStyles.marginTop], `text-${mergedStyles.textColor}`, mergedStyles.className);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== error || $[3] !== t2) {
    t3 = <span className={t2}>{error}</span>;
    $[2] = error;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};